<template>
  <Form @submit="onSubmit">
    <div>
      <label for="submittedAnswer" class="sr-only">Answer</label>
      <Field type="text" name="submittedAnswer" autocomplete="off" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-slate-500 focus:border-slate-500 sm:text-sm dark:bg-gray-900 dark:text-white" placeholder="" rules="required" />
    </div>

    <ErrorMessage name="submittedAnswer" class="mt-1 text-sm text-red-500" />

    <TaskSubmitButton :cta="submitBtnCta" :correct="answer.correct" @skip="$emit('skip', $event)" />
  </Form>
</template>

<script>
import { Field, Form, ErrorMessage, defineRule } from "vee-validate";
import { getFunctions, httpsCallable } from "firebase/functions";
import TaskSubmitButton from "../task/TaskSubmitButton.vue";
import { ref } from "vue";

defineRule("required", (value) => {
  if (!value) {
    return `No answer? Take a guess.`;
  }
  return true;
});

export default {
  emits: ["answer"],
  components: {
    Form,
    Field,
    ErrorMessage,
    TaskSubmitButton,
  },

  props: {
    solution: Array,
  },
  setup(props, { emit }) {
    const answer = ref({
      item: null,
      correct: null,
    });
    const submitBtnCta = ref("Submit");

    function hammingDistance(str1, str2) {
      var dist = 0;
      str1 = str1.toLowerCase();
      str2 = str2.toLowerCase();
      for (var i = 0, j = Math.max(str1.length, str2.length); i < j; i++) {
        if (!str1[i] || !str2[i] || str1[i] !== str2[i]) {
          dist++;
        }
      }
      return dist;
    }

    async function onSubmit(e) {
      // Check 1: string comparison, allow for light spelling mistakes
      let correct = hammingDistance(props.solution[0], e.submittedAnswer) <= 2 ? true : false;

      //Check 2: if string comparison fails, check is answer has correct meaning
      if (!correct) {
        submitBtnCta.value = "Evaluating answer, please wait...";
        const functions = getFunctions();
        try {
          const gpt3EvalAnswer = httpsCallable(functions, "gpt3EvalAnswer");
          const gpt3EvalResponse = await gpt3EvalAnswer({
            answer: props.solution[0],
            userAnswer: e.submittedAnswer,
          });
          correct = gpt3EvalResponse.data.correct;
        } catch (e) {
          correct = false;
        }
      }
      answer.value = {
        item: e.submittedAnswer,
        correct: correct,
      };

      emit("answer", answer.value);
    }

    return {
      answer,
      submitBtnCta,
      onSubmit,
    };
  },
};
</script>
